import { getPlatformContext } from "./utils";
import { useContextSelector } from "./store";

import type { PlatformProviderState } from "./types";

export function usePlatformContext<TSelected>(
  selectorFn: (state: PlatformProviderState<"native" | "web">) => TSelected
): TSelected {
  return useContextSelector(getPlatformContext(), selectorFn);
}

/**
 * Components
 */
export const usePositionAwarePortalComponent = () => {
  return usePlatformContext((state) => state.components.PositionAwarePortal);
};

export const useModalComponent = () => {
  return usePlatformContext((state) => state.components.Modal);
};

export const useFocusLockComponent = () => {
  return usePlatformContext((state) => state.components.FocusLock);
};

export const useAutoFocusInsideComponent = () => {
  return usePlatformContext((state) => state.components.AutoFocusInside);
};

/**
 * Hooks
 */
export const useNavigationHook = () => {
  const useNavigation = usePlatformContext(
    (state) => state.hooks.useNavigation
  );

  return useNavigation();
};

/**
 * Modules
 */
export const useDocumentPickerModule = () => {
  return usePlatformContext((state) => state.modules.DocumentPicker);
};

export const useImagePickerModule = () => {
  return usePlatformContext((state) => state.modules.ImagePicker);
};
